import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { CoreModalComponent } from '../core-modal/core-modal.component';
import { CoreButtonComponent } from '../core-button/core-button.component';
import { AlertService } from '@shared/services/alert.service';

import { AppIcons } from '@core/utilities/icons';

@Component({
  selector: 'app-core-alert',
  standalone: true,
  imports: [
    CommonModule,
    FontAwesomeModule,
    CoreModalComponent,
    CoreButtonComponent
  ],
  templateUrl: './core-alert.component.html',
  styleUrl: './core-alert.component.scss'
})
export class CoreAlertComponent {
  icons: typeof AppIcons = AppIcons;

  alertIcon = {
    success: AppIcons.fasCircleCheck,
    error: AppIcons.fasCircleXmark,
    confirm: AppIcons.fasCircleQuestion
  };

  alert$ = this.alertService.state$;

  constructor(private alertService: AlertService) {}

  accept() {
    this.alertService.accept();
  }

  cancel() {
    this.alertService.cancel();
  }

  close() {
    this.alertService.cancel();
  }

}
